import React from "react";
import { trim } from "lodash";
import { Button, ButtonSize, ButtonVariant, MITheme } from "@spectrumselect/mi-ui-react";
import { S } from "../../auth/sdk";

export interface InformationResponseProps {
  title: string;
  text: string;
  buttonText: string;
  resolve: (value: any | PromiseLike<any>) => void;
}

export const InformationResponse: React.FunctionComponent<InformationResponseProps> = (props) => {
  const onContinueButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    props.resolve(S.ConfirmationInput.create(-1));
  }
  return (
    <form className="InformationResponse">
      <h1 className="App_pageTitle">{props.title}</h1>
      {trim(props.text).length > 0 && <p className="App_formDesc">{props.text}</p>}

      <div className="App_formButtonGroup">
        <Button variant={ButtonVariant.primary} type="submit" onClick={onContinueButtonClick} theme={MITheme.dark} size={ButtonSize.large}>
          {props.buttonText}
        </Button>
      </div>
    </form>
  );
}
